export default __webpack_public_path__ + "static/media/IkonIngenAlternativeInvesteringer.aa93db95.svg";